import {DomainObject} from 'shared/store';
import { observable, makeObservable } from 'mobx';

class AttachedLink extends DomainObject {
  title;
  linkTitle;
  url;

  constructor(other) {
    super();

    makeObservable(this, {
      title: observable,
      linkTitle: observable,
      url: observable
    });

    this.merge(other);
  }
}

export default AttachedLink;
